import { useMemo } from 'preact/hooks'

export function useNormaliseSuggestions(results) {
  return useMemo(() => {
    const suggestions = []

    if (results?.items?.length > 0) {
      suggestions.push(
        ...results.items.map((result) => ({
          query: result.query,
          label: result.label
        }))
      )
    }

    if (results?.suggested) {
      suggestions.push({
        query: results.suggested.text,
        label: results.suggested.text
      })
    }

    if (results?.results?.length > 0) {
      suggestions.push(
        ...results.results.map((result) => ({
          query: result.url,
          label: result.name
        }))
      )
    }

    if (results?.alternatives?.length > 0) {
      suggestions.push(
        ...results.alternatives.map((alternative) => ({
          query: alternative.text,
          label: alternative.text
        }))
      )
    }

    // Remove duplicates
    const uniqueSuggestions = suggestions.reduce((acc, current) => {
      const x = acc.find((item) => item.query === current.query)
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])
    return uniqueSuggestions
  }, [results?.items, results?.results, results?.alternatives, results?.suggested])
}
